import { render } from "./TooltipComponent.vue?vue&type=template&id=709f3caf"
import script from "./TooltipComponent.vue?vue&type=script&lang=js"
export * from "./TooltipComponent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__